import { h, Fragment } from "preact";
import { useState, useContext } from "preact/hooks";
import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    MenuItem,
    TextField,
    ToggleButtonGroup,
    ToggleButton,
    Typography,
    Stack
} from "@mui/material";

import Uploader from "../Uploader";
import { AppContext } from "../../AppContext";
import Localisation3 from "../Common/Localisation3";
import SirenField from "../Common/SirenField";
import DownloadFile from "../Common/DownloadFile";


export default function AmbassadorDetails({ uid, upperState, handleChange, handleChangeCheckbox, fireSubmit }) {
    //console.log("AmbassadorDetails", upperState)

    const [state, setState] = useState({ init: false });

    const app = useContext(AppContext);

    const delTof = (idx) => {
        //console.log(idx)
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/41d9da64d77741458c05eab61e440aca/" + idx, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":

                        window.location.reload();
                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };
    // useEffect(() => {
    //     const id_doc = state.user_id_doc ? state.user_id_doc_uid : state.user_id_doc2_uid;
    //     const requestOptions = {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },

    //         body: JSON.stringify({
    //             //user_uid: uid,
    //             //
    //             target_uid: id_doc
    //         }),
    //     };
    //     fetch("/upload/e48dcaabe83040548c5291e9d3b9d716/iddoc", requestOptions)
    //         .then((response) => {
    //             return response.json();
    //         })
    //         .then((res) => {
    //             switch (res.res) {
    //                 case "ok":
    //                     //reset
    //                     setState({ ...state, has_session_id: true, session_uid: res.pld })

    //                     break;

    //                 case "err":
    //                     break;
    //                 default:
    //                     break;
    //             }
    //         });

    // }, []);

    return (
        <div style="padding-top: 10px; ">
            <Stack spacing={2}>
                <Typography variant="h5" >
                    Vous agissez en tant que :
                </Typography>
                <ToggleButtonGroup
                    color="primary"
                    value={upperState.ambassador_organization_or_individual}
                    exclusive
                    onChange={handleChange}
                >
                    <ToggleButton value="1" name="ambassador_organization_or_individual">Particulier</ToggleButton>
                    <ToggleButton value="2" name="ambassador_organization_or_individual">Sociéte</ToggleButton>
                </ToggleButtonGroup>
                {upperState.ambassador_organization_or_individual === "2" && <Stack>
                    <ListOfChoices types={upperState.types} handleChange={handleChange} type={upperState.ambassador_organization_type_id} />
                    <Box display="flex" justifyContent="space-between" alignItems={"center"}>
                        <Box style=" width: 100%;">
                            <TextField
                                id="ambassador_organization_name"
                                name="ambassador_organization_name"
                                variant="outlined"
                                placeholder="Raison sociale"
                                fullWidth
                                margin="dense"
                                size="small"
                                value={upperState.ambassador_organization_name}
                                onChange={handleChange}
                            />
                        </Box>
                        <Box style=" width: 100%;">

                            <SirenField
                                id="ambassador_organization_id"
                                name="ambassador_organization_id"
                                value={upperState.ambassador_organization_id}
                                handleChange={handleChange}
                                placeholder="SIREN"
                            />
                        </Box>
                    </Box>

                    {upperState.adresses_id && <FormControlLabel
                        control={
                            <Checkbox checked={upperState.ambassador_same_address} onChange={handleChangeCheckbox} name="ambassador_same_address" color="primary" />
                        }
                        label={"Domicilié également au " + upperState.addr_line1 + ", " + upperState.addr_zip_code + " " + upperState.addr_city}
                    />}
                    {!upperState.ambassador_same_address &&
                        <Grid container spacing={2}>
                            <Grid item xs={(!state.new_loc && upperState.ambassador_addr_line1) ? 6 : 12}>
                                <Stack spacing={1} justifyContent="flex-start">
                                    {(!upperState.ambassador_addr_line1 || state.new_loc) && <Localisation3
                                        upperState={{ addr_line1: upperState.ambassador_addr_line1, addr_zip_code: upperState.ambassador_addr_zip_code, addr_city: upperState.ambassador_addr_city }}
                                        mode="AMB2"
                                        upperSendLoc={handleChange}
                                    />}
                                    {!state.new_loc && upperState.ambassador_addr_line1 && <div>
                                        <Button variant="contained" onClick={() => { setState({ ...state, new_loc: true }) }}>Modifier</Button>
                                    </div>}
                                    {state.new_loc && <div>

                                        <Button variant="contained" onClick={() => { setState({ ...state, new_loc: false }) }}>Annuler</Button>
                                    </div>}
                                </Stack>
                            </Grid>
                            {(!state.new_loc && upperState.ambassador_addr_line1) && <Grid item xs={6}>
                                {upperState.ambassador_addr_line1 !== "" && <Stack spacing={1} style="margin-top: 10px;">

                                    <Typography variant="h5">Adresse actuelle</Typography>


                                    {upperState.ambassador_addr_line1 !== "" &&

                                        <Typography variant="body1">{upperState.ambassador_addr_line1}</Typography>

                                    }
                                    {upperState.ambassador_addr_line2 && <Typography variant="body1">{upperState.ambassador_addr_line2}</Typography>}

                                    <Box display={"flex"} justifyContent="flex-start" alignItems={"center"} >
                                        <Box>
                                            <Typography variant="body1">{upperState.ambassador_addr_zip_code}</Typography>
                                        </Box>
                                        <Box p={1}>
                                            <Typography variant="body1">{upperState.ambassador_addr_city}</Typography>
                                        </Box>
                                    </Box>

                                </Stack>}
                                {upperState.ambassador_addr_line1 === "" && <Typography variant="body1" style="margin-top: 10px;">Adresse incomplète</Typography>}

                            </Grid>}
                        </Grid>
                    }
                </Stack>}
                <Typography variant="h5" style="margin-top: 20px;">
                    Votre justificatif d'identité
                </Typography>
                {upperState.user_id_doc_link !== null && upperState.user_id_doc2_link !== null && <Typography variant="body1">Vos documents d'identité</Typography>}
                {upperState.user_id_doc_link !== null && <Box display="flex" justifyContent="flex-star" alignItems="center">
                    <Box p={1}>
                        <img
                            src={`${THUMBS_URL}/${upperState.user_id_doc_link}-100.jpg`}
                            style="border: 1px solid gray; border-radius: 5px;"
                        />
                    </Box>
                    <Box p={1}>
                        <Typography variant="body1">Document 1</Typography>
                        <Typography variant="caption">{upperState.doc1.name} - {upperState.doc1.sz}</Typography>
                    </Box>
                    <Box p={1}>
                        <DownloadFile f={upperState.doc1} mode="iddoc" />
                    </Box>
                    <Box p={1}>
                        <Button onClick={() => {
                            app.refPopUp.current.handleChangeState(
                                {
                                    opened: true,
                                    type: "002",
                                    params: {
                                        title: "Attention",
                                        body: (
                                            <div>
                                                <Typography variant="h5" gutterBottom>
                                                    Voulez vous vraiment supprimer ce document?
                                                </Typography>
                                            </div>
                                        ),
                                        yes_action: () => {
                                            delTof(upperState.user_id_doc_uid);
                                        }
                                    }
                                })

                        }}>Supprimer</Button>
                    </Box>
                </Box>}
                {upperState.user_id_doc2_link !== null &&
                    <Box display="flex" justifyContent="flex-star" alignItems="center">
                        <Box p={1}>
                            <img
                                src={`${THUMBS_URL}/${upperState.user_id_doc2_link}-100.jpg`}
                                style="border: 1px solid gray; border-radius: 5px;"

                            />
                        </Box>
                        <Box p={1}>
                            <Typography variant="body1">Document 2</Typography>
                            <Typography variant="caption">{upperState.doc2.name} - {upperState.doc2.sz}</Typography>
                        </Box>
                        <Box p={1}>
                            <DownloadFile f={upperState.doc2} mode="iddoc" />
                        </Box>
                        <Box p={1}>
                            <Button onClick={() => {
                                app.refPopUp.current.handleChangeState(
                                    {
                                        opened: true,
                                        type: "002",
                                        params: {
                                            title: "Attention",
                                            body: (
                                                <div>
                                                    <Typography variant="h5" gutterBottom>
                                                        Voulez vous vraiment supprimer ce document?
                                                    </Typography>
                                                </div>
                                            ),
                                            yes_action: () => {
                                                delTof(upperState.user_id_doc2_uid);
                                            }
                                        }
                                    })

                            }}>Supprimer</Button>
                        </Box>
                    </Box>}

                {(upperState.session_uid) && (
                    // {(upperState.user_id_doc === null || upperState.user_id_doc2 === null) && (
                    <div onClick={() => {
                        console.log("upperState", upperState)
                        if (upperState.changes) { fireSubmit() }
                    }}>
                        <Typography variant="body1">Téléchargez une pièce d'identité</Typography>
                        <Uploader mode="iddoc" upperState={{ ...state, ...upperState }} max={1} />
                    </div>
                )}
            </Stack>

        </div >

    );
}

const ListOfChoices = ({ types, type, handleChange }) => {
    return (
        <TextField
            id="ambassador_organization_type_id"
            name="ambassador_organization_type_id"
            select
            label=""
            value={type ? type : 0}
            onChange={handleChange}
            //helperText=""
            variant="outlined"
            size="small"
        >
            <MenuItem key={0} value={0}>
                <em>Choisir une forme sociale</em>
            </MenuItem>
            {types.map((option) => (
                <MenuItem key={option.i} value={option.i}>
                    {option.d}
                </MenuItem>
            ))}
        </TextField>
    );
};


